import React from "react";
import {
  Table,
  Stack,
  TableRow,
  TableBody,
  Typography,
  TableHead,
  TableSortLabel,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  Grid,
  FormControl,
  InputLabel,
  Select,
  styled,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Popover,
  Link,
} from "@mui/material";
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import config from "../config";
import i18n from "../i18n";
import Iconify from "../components/iconify/Iconify";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { getOptionData } from "../utils/commonUtils";
import { useNavigate, useParams } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import {
  deleteHandrail,
  editHandrail,
  getHandrailList,
} from "../services/handrail.service";
import Swal from "sweetalert2";
import { convertMessageCodeToMessage } from "src/utils/messageCodeToMessage";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const tableHeaders = [
  {
    id: "airport",
    label: i18n.t("airport"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "mandate_number",
    label: i18n.t("mandate_number"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "date",
    label: i18n.t("date"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "hour",
    label: i18n.t("hour"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "trades",
    label: i18n.t("trades"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "information",
    label: i18n.t("information"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "importance",
    label: i18n.t("importance"),
    alignCenter: true,
    sortable: true,
  },
  { id: "" },
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:nth-of-type(odd):hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:nth-of-type(even):hover": {
    backgroundColor: "white",
  },
}));

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};
class HandrailsCombinedTable extends React.Component {
  constructor(props) {
    super(props);
    this.airportId = props?.airportId;
    this.tableLimitOptions = config?.tableLimitOptions;
    this.tableLimitOptions = config?.tableLimitOptions;

    this.state = {
      handrails: [],
      handrail: {},
      page: 1,
      search: "",
      limit: 25,
      skip: 0,
      total_handrails: 0,
      tableLoader: false,
      orderBy: { sort_key: "airport", sort_order: true },
      showIsOpenDropDown: false,
      deleteHandrailPopUp: false,
      isScrolling: false,
    };
    this.useStyles = {
      sticky: {
        position: "sticky",
        left: "0",
        zIndex: "11",
      },
    };
  }

  componentDidMount() {
    this.getHandrails();
  }

  async setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async getHandrails(action) {
    this.setState({
      tableLoader: true,
    });
    let query = {
      limit: this.state.limit,
      skip: this.state.skip,
      sort_key: this.state?.orderBy?.sort_key,
      sort_order: this.state?.orderBy?.sort_order
        ? "ASC"
        : "DESC",
      airport: this.airportId,
    };

    let handrails = await getHandrailList(query);
    if (handrails.error) {
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: handrails?.error?.error_code
          ? i18n.t(convertMessageCodeToMessage(handrails?.error_code))
          : handrails?.error,
        confirmButtonText: i18n.t("ok"),
        confirmButtonColor: config.primaryColor,
      });
      this.setState({
        tableLoader: false,
      });
      return;
    }
    await this.setStateAsync({
      tableLoader: false,
      handrails: handrails.handrails,
      total_handrails: handrails.count,
    });
  }
  handleDropdown = (event, data, rowIndex, key) => {
    this.setState({
      [key]: event.currentTarget,
      handrail: data,
      rowIndex,
    });
  };
  handleCloseDropdown = (key) => {
    this.setState({
      [key]: null
    });
  };

  handleClick = (event, data, rowIndex, key) => {
    this.setState({
      [key]: event.currentTarget,
      handrail: data,
      rowIndex,
    });
  };
  handleClose = (key) => {
    this.setState({
      [key]: null,
    });
  };

  handleRowClick = (handrailId) => {
    let url = `/handrails/${handrailId}`;
    if (this.props?.airportId) {
      url += `?airport=${this.props?.airportId}`;
    }
    this.props.navigate(url);
  };

  handleHandrailsTableAction = async (action, data, rowData, key, rowIndex) => {
    if (action === "pagination") {
      await this.setState({
        skip: (data - 1) * this.state?.limit,
        page: data,
      });
      this.getHandrails();
    } else if (action === "limit") {
      await this.setState({
        limit: data,
      });
      this.getHandrails();
    } else if (action === "popOverAction") {
      this.setState({
        open: data.currentTarget,
        handrail: rowData,
      });
    } else if (action === "sort") {
      /**These keys are inside airport key from BE,
       * the sort key for these are like : airport.[keyName]
       */
      if (config?.airportJsonKeys.includes(data.toLowerCase())) {
        await this.setState({
          orderBy: {
            sort_key:
              data === "airport"
                ? `airport_name`
                : `airport_${data.toLowerCase()}`,
            sort_order: !this.state?.orderBy?.sort_order,
          },
        });
      } else {
        await this.setState({
          orderBy: {
            sort_key: data,
            sort_order: !this.state?.orderBy?.sort_order,
          },
        });
      }
      this.getHandrails();
    } else if (action === "closeMenu") {
      this.setState({
        open: null
      })
    } else if (action === "update") {
      if (rowData[key] === data) return;
      let backUpData = { rowData, rowIndex };
      let payload = { ...rowData };
      payload[key] = data;
      let tempData = this.state?.handrails;
      tempData[rowIndex] = { ...payload };
      payload["airport"] = payload["airport"]?._id;
      payload["offer"] = payload["offer"]?._id;

      let temp_btee_sa_employees = rowData?.btee_sa_employees?.map(
        (data) => data?._id
      );
      let temp_airport_employees = rowData?.airport_employees?.map(
        (data) => data?._id
      );

      payload["btee_sa_employees"] = temp_btee_sa_employees;
      payload["airport_employees"] = temp_airport_employees;
      payload["airport"] = rowData?.airport?._id;
      payload["offer_number"] = rowData?.offer_number?._id;
      payload["trades"] = rowData?.trades;
      this.setState({
        handrails: tempData,
      });
      this.updateHandrailData(payload, payload?._id, backUpData);
    } else if (action === "deleteHandrail") {
      await this.setState({
        deleteHandrailPopUp: true,
        open: null
      });
    } else if (action === "closeConfirmationPopUp") {
      this.setState({
        deleteHandrailPopUp: false,
      });
    } else if (action === "proceed") {
      this.setState({
        deleteHandrailPopUp: false,
      });
      this.handleDeleteHandrail(this.state?.handrail._id);
    }
  };

  async updateHandrailData(payload, handrailId, backUpData) {
    let response = await editHandrail(handrailId, payload);
    if (response && response.error) {
      let tempData = this.state?.handrails;
      tempData[backUpData?.rowIndex] = backUpData?.rowData;
      this.setState({
        handrails: tempData,
      });
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: response?.error?.error_code
          ? i18n.t(convertMessageCodeToMessage(response?.error_code))
          : response?.error,
        confirmButtonText: i18n.t("ok"),
        confirmButtonColor: config.primaryColor,
      });
      return;
    }

    if (response && response.handrail) {
      // Swal toast
      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: i18n.t("success"),
        text: i18n.t("handrail_updated_successfully"),
        showConfirmButton: false,
        timer: config.toastDelay,
        timerProgressBar: true,
        customClass: {
          container: "my-swal",
        },
      });
    }
  }
  async handleDeleteHandrail(handrailId) {
    this.setState({
      pageLoader: true,
    });
    let response = await deleteHandrail(handrailId);

    if (response && response.error) {
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: response?.error?.error_code
          ? i18n.t(convertMessageCodeToMessage(response?.error_code))
          : response?.error,
        confirmButtonText: i18n.t("ok"),
        confirmButtonColor: config.primaryColor,
      });
      return;
    }

    if (response) {
      await this.getHandrails();
      this.setState({
        pageLoader: false,
      });
    }
  }


  render() {
    return (
      <>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            mt:2
          }}
        >
          {(this.props?.showTitle) ? (
            <Typography variant="h4">
              {i18n.t("handrails")}
            </Typography>
          ) : null}

          {(this.props?.showAdd) ? (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              className="BtnWidth"
              onClick={() => {
                this.props.navigate(
                  `/handrails/add?airport=${this.airportId}`
                );
              }}
            >
              {i18n.t("handrail")}
            </Button>
          ) : null}
        </Stack>

        <Card style={{ boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)", borderRadius: '5px' }}>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <ScrollContainer style={{ width: "100%", maxHeight: 'calc(100vh - 255px)' }} hideScrollbars={false}>
              <Table stickyHeader size="small" aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {tableHeaders.map((headCell) => (
                      <StyledTableCell
                        style={
                          ["airport"].includes(headCell.id)
                            ? this.useStyles?.sticky
                            : {}
                        }
                        key={headCell.id}
                        align={
                          headCell.alignCenter
                            ? "center"
                            : headCell.alignRight
                              ? "right"
                              : "left"
                        }
                      >
                        {headCell.sortable ? (
                          <TableSortLabel
                            direction={
                              this.state.orderBy?.sort_order ? "asc" : "desc"
                            }
                            onClick={async (e) => {
                              this.handleHandrailsTableAction("sort", headCell.id);
                            }}
                            style={{ color: "white" }}
                            hideSortIcon={headCell.sortable ? false : true}
                            active={
                              this.state?.orderBy?.sort_key === headCell.id
                            }
                          >
                            {headCell.label}
                            {this.state?.orderBy?.sort_key === headCell.id &&
                              headCell.sortable ? (
                              <Box sx={{ ...visuallyHidden }}>
                                {this.state?.orderBy?.sort_order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        ) : (
                          <Typography variant="subtitle2">
                            {headCell.label}
                          </Typography>
                        )}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!this.state?.tableLoader &&
                    this.state?.handrails?.map((row, index) => {
                      const {
                        _id,
                        airport,
                        offer_number,
                        date,
                        hour,
                        trades,
                        information,
                        importance
                      } = row;

                      return (
                        <StyledTableRow key={_id} tabIndex={-1}>
                          <StyledTableCell
                            scope="row"
                            style={{
                              position: "sticky",
                              left: 0,
                              backgroundColor: index % 2 ? "white" : "#F6F7F8",
                              minWidth: "10rem",
                              cursor: "pointer",
                            }}
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={6}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  <Link onClick={() => this.props.navigate(`/airports/airportDetails/${airport?._id}`)}>{airport?.name}</Link>
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  <Link
                                    onClick={() => {
                                      this.props.navigate(
                                        `/offers/${offer_number?._id}`
                                      );
                                    }}
                                  >
                                    {offer_number?.mandate_number}
                                  </Link>
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align={"center"}
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              style={{ margin: "auto", display: "block" }}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {moment(date).format(i18n.t("OPTIONS.date_format"))}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="center"
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={hour}
                              style={{ margin: "auto", display: "block" }}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {moment(hour, 'HH:mm').format(i18n.t("OPTIONS.time_format"))}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="center"
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={trades}
                              justifyContent='center'
                              style={{ display: "flex" }}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {i18n.t(trades)}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>


                          <StyledTableCell
                            align="right"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.handleRowClick(_id);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              justifyContent='center'
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {information}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              justifyContent='center'
                              sx={{ display: 'flex' }}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                                style={{ display: "block" }}
                              >
                                <Typography variant="subtitle2">
                                  <span
                                    style={{
                                      backgroundColor: getOptionData(
                                        config?.importanceOptions,
                                        importance
                                      )?.color,
                                      color: getOptionData(
                                        config?.importanceOptions,
                                        importance
                                      )?.textColor,
                                      padding: 5,
                                      borderRadius: 5,
                                      fontSize: 12,
                                      textWrap: "nowrap",
                                      fontWeight: "bold",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      this.handleDropdown(
                                        e,
                                        row,
                                        index,
                                        "showImportanceDropDown"
                                      );
                                    }}
                                    aria-controls={
                                      Boolean(this.state.showImportanceDropDown)
                                        ? "basic-menu"
                                        : undefined
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={
                                      Boolean(this.state.showImportanceDropDown)
                                        ? "true"
                                        : undefined
                                    }
                                  >
                                    {i18n.t(importance)}
                                  </span>
                                  <Menu
                                    id="basic-menu"
                                    open={Boolean(
                                      this.state.showImportanceDropDown
                                    )}
                                    anchorEl={this.state.showImportanceDropDown}
                                    onClose={() => {
                                      this.handleCloseDropdown(
                                        "showImportanceDropDown"
                                      );
                                    }}
                                  >
                                    {config?.importanceOptions?.map((option) => {
                                      return (
                                        <MenuItem
                                          value={option?.value}
                                          onClick={() => {
                                            this.handleHandrailsTableAction(
                                              "update",
                                              option?.value,
                                              this.state.handrail,
                                              "importance",
                                              this.state.rowIndex
                                            );
                                            this.handleCloseDropdown(
                                              "showImportanceDropDown"
                                            );
                                          }}
                                        >
                                          {option?.label}
                                        </MenuItem>
                                      );
                                    })}
                                  </Menu>
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            <IconButton
                              size="large"
                              sx={{ padding: '2px' }}
                              color="inherit"
                              onClick={(e) => {
                                this.handleHandrailsTableAction("popOverAction", e, row);
                              }}
                            >
                              <Iconify icon={"eva:more-vertical-fill"} />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  {this.state?.tableLoader && (
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        colSpan={"100%"}
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}

                  {!this.state?.tableLoader &&
                    this.state.handrails?.length === 0 && (
                      <TableRow>
                        <TableCell
                          style={{ textAlign: "center" }}
                          colSpan={"100%"}
                        >
                          {i18n.t('no_records_found')}
                        </TableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </ScrollContainer>
          </Paper>
        </Card>

        {this.state.handrails?.length !== 0 && (
          <Grid
            container
            spacing={2}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid></Grid>
            <Grid item>
              <Pagination
                count={Math.ceil(this.state.total_handrails / this.state.limit)}
                shape="rounded"
                size="large"
                onChange={async (event, page) => {
                  this.handleHandrailsTableAction("pagination", page);
                }}
                page={this.state.page}
                showFirstButton={true}
                showLastButton={true}
                boundaryCount={2}
                style={{ margin: 20 }}
              />
            </Grid>

            <Grid item style={{ width: "10%" }}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Limit</InputLabel>
                <Select
                  value={this.state.limit}
                  label="Limit"
                  size="small"
                  onChange={async (e) => {
                    this.handleHandrailsTableAction("limit", e?.target?.value);
                  }}
                >
                  {this.tableLimitOptions?.map((limit) => {
                    return (
                      <MenuItem value={limit?.value}>{limit?.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Popover
              open={Boolean(this.state.open)}
              anchorEl={this.state.open}
              onClose={() => {
                this.handleHandrailsTableAction("closeMenu");
              }}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  p: 1,
                  width: 140,
                  "& .MuiMenuItem-root": {
                    px: 1,
                    typography: "body2",
                    borderRadius: 0.75,
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  this.handleHandrailsTableAction("closeMenu");
                  let url = `/handrails/${this.state.handrail._id}`;
                  if (this.props?.airportId) {
                    url += `?airport=${this.props?.airportId}`;
                  }
                  this.props.navigate(url);
                }}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                {i18n.t("edit")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.handleHandrailsTableAction("deleteHandrail");
                }}
              >
                <Iconify icon={"ant-design:delete-filled"} sx={{ mr: 2 }} />
                {i18n.t("delete")}
              </MenuItem>
            </Popover>
            <Dialog
              open={this.state?.deleteHandrailPopUp}
              onClose={() => {
                this.handleHandrailsTableAction("closeConfirmationPopUp");
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{i18n.t("delete")}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {i18n.t('are_you_sure_of_deleting_this_action_is_irreversible')}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.handleHandrailsTableAction("closeConfirmationPopUp");
                  }}
                  autoFocus
                >
                  {i18n.t("cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    this.handleHandrailsTableAction("proceed");
                  }}
                >
                  {i18n.t("proceed")}
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}
      </>
    );
  }
}

// Wrap and export
export default function (props) {
  const navigate = useNavigate();
  const params = useParams();
  return <HandrailsCombinedTable {...props} navigate={navigate} params={params} />;
}
